import * as LocalizationActions from "../actions/Localization.Actions";
import { ActionType } from "../actions/Helpers";

export const LocalizationReducer = (state: any = {}, action: LocalizationActions.Action): any => {
  switch (action.type) {
    case ActionType.SET_LOCALES:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
